import { connect } from 'react-redux'
import QCViewWrapper from './QCViewWrapper'
import { runIndividualQc, certifyQc, createQc, updateQc, getQc, deleteQcJob, cancelQcJob } from '../../../store/qc'
import { getControlMaterials } from '../../../store/controlMaterials'

const mapDispatchToProps = {
  getControlMaterials,
  getQc,
  runIndividualQc,
  certifyQc,
  createQc,
  updateQc,
  deleteQcJob,
  cancelQcJob,
}

const mapStateToProps = (state, ownProps) => {
  let qcResults = {}
  if (ownProps.params.qcId !== 'create') {
    qcResults = state.qc[ownProps.params.qcId]
  }
  return {
    site: state.site,
    controlMaterials: state.controlMaterials,
    qcResults: qcResults
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QCViewWrapper)



// WEBPACK FOOTER //
// ./src/routes/QC/components/QCContainer.jsx